<template>
  <div :class="imgClass" class="sc-thumbnail">
    <img
      ref="image"
      :src="imgSrc"
      :alt="imgAlt"
      :class="{ pointer: openLink }"
      :style="{ transform: transform }"
      @click="viewOriginal"
    />
    <i v-if="openLink" class="fas fa-external-link-alt"></i>
  </div>
</template>

<script>
import EXIF from "exif-js"

export default {
  name: "HelperThumbnail",
  props: {
    imgAlt: {
      type: String,
      default: "",
    },
    imgSrc: {
      type: String,
      default: undefined,
    },
    imgClass: {
      type: String,
      default: "",
    },
    openLink: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      orientation: 1,
      transform: "rotate(0deg)",
    }
  },
  watch: {
    orientation(val) {
      switch (val) {
        case 1:
          this.transform = "rotate(0deg)"
          break
        case 2:
          this.transform = "rotate(0deg)"
          break
        case 3:
          this.transform = "rotate(180deg)"
          break
        case 4:
          this.transform = "rotate(180deg)"
          break
        case 5:
          this.transform = "rotate(90deg)"
          break
        case 6:
          this.transform = "rotate(90deg)"
          break
        case 7:
          this.transform = "rotate(270deg)"
          break
        case 8:
          this.transform = "rotate(270deg)"
          break
        default:
          this.transform = "rotate(0deg)"
          break
      }
    },
  },
  mounted() {
    const vm = this

    const xhr = new XMLHttpRequest()
    xhr.onload = function xhrOnloadHandler() {
      const image = new Image()
      image.onload = function imageOnloadHandler() {
        EXIF.getData(xhr.response, function legacyCallback() {
          vm.orientation = EXIF.getTag(this, "Orientation")
        })
      }
      image.src = URL.createObjectURL(xhr.response)
    }
    xhr.open("GET", vm.imgSrc)
    xhr.responseType = "blob"
    xhr.send()
  },
  methods: {
    viewOriginal() {
      if (this.openLink) {
        if (/^data:image/.test(this.imgSrc)) {
          const newWindow = window.open("")
          const img = new Image()
          img.src = this.imgSrc

          setTimeout(() => {
            newWindow.document.title = "Original Image"
            newWindow.document.body.appendChild(img)
          }, 10)
        } else {
          window.open(this.imgSrc)
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.sc-thumbnail {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-shadow: 0 0 1px 0 rgba($color: $black, $alpha: 0.4);

  i {
    opacity: 0;
    position: absolute;
    background-color: $orange;
    font-size: 12px;
    color: $white;
    top: -30px;
    right: -28px;
    border-radius: 20em;
    width: 60px;
    height: 60px;
    line-height: 85px;
    padding-left: 12px;
    transition: opacity 0.25s ease;
  }
  img {
    height: 100%;
    object-fit: cover;
    position: relative;

    &:hover + i {
      opacity: 1;
    }
  }
}
</style>
